(function() {
  function detect() {
    var t = true;
    var o;

    var ua = navigator.userAgent;
    var ie = /(msie|trident)/i.test(ua);
    var chrome = /chrome|crios/i.test(ua);
    var phantom = /phantom/i.test(ua);
    var safari = /safari/i.test(ua) && !chrome && !phantom;
    var iphone = /iphone/i.test(ua);
    var ipad = /ipad/i.test(ua);
    var touchpad = /touchpad/i.test(ua);
    var android = /android/i.test(ua);
    var opera = /opera/i.test(ua) || /opr/i.test(ua);
    var firefox = /firefox/i.test(ua);
    var gecko = /gecko\//i.test(ua);
    var seamonkey = /seamonkey\//i.test(ua);
    var webkitVersion = /version\/(\d+(\.\d+)?)/i;
    var firefoxVersion = /firefox\/(\d+(\.\d+)?)/i;

    if (ie)
      return {
        name: 'Internet Explorer',
        msie: t,
        version: ua.match(/(msie |rv:)(\d+(\.\d+)?)/i)[2]
      };

    if (opera)
      return {
        name: 'Opera',
        opera: t,
        version: ua.match(webkitVersion)
          ? ua.match(webkitVersion)[1]
          : ua.match(/opr\/(\d+(\.\d+)?)/i)[1]
      };

    if (chrome)
      return {
        name: 'Chrome',
        webkit: t,
        chrome: t,
        version: ua.match(/(?:chrome|crios)\/(\d+(\.\d+)?)/i)[1]
      };

    if (phantom)
      return {
        name: 'PhantomJS',
        webkit: t,
        phantom: t,
        version: ua.match(/phantomjs\/(\d+(\.\d+)+)/i)[1]
      };

    if (touchpad)
      return {
        name: 'TouchPad',
        webkit: t,
        touchpad: t,
        version: ua.match(/touchpad\/(\d+(\.\d+)?)/i)[1]
      };

    if (iphone || ipad) {
      o = {
        name: iphone ? 'iPhone' : 'iPad',
        webkit: t,
        mobile: t,
        ios: t,
        iphone: iphone,
        ipad: ipad
      };

      if (webkitVersion.test(ua)) {
        o.version = ua.match(webkitVersion)[1];
      } else {
        // Web browsers inside apps do not send the Version/x.x substring
        o.version = undefined;
      }

      return o;
    }

    if (android)
      return {
        name: 'Android',
        webkit: t,
        android: t,
        mobile: t,
        version: (ua.match(webkitVersion) || ua.match(firefoxVersion))[1]
      };

    if (safari)
      return {
        name: 'Safari',
        webkit: t,
        safari: t,
        version: ua.match(webkitVersion)[1]
      };

    if (gecko) {
      o = {
        name: 'Gecko',
        gecko: t,
        mozilla: t,
        version: ua.match(firefoxVersion)[1]
      };
      if (firefox) {
        o.name = 'Firefox';
        o.firefox = t;
      }
      return o;
    }

    if (seamonkey)
      return {
        name: 'SeaMonkey',
        seamonkey: t,
        version: ua.match(/seamonkey\/(\d+(\.\d+)?)/i)[1]
      };

    return {};
  } // detect

  var b = detect();

  var ok = false;
  if (
    (b.msie && b.version >= 10) ||
    (b.chrome && b.version >= 24) ||
    (b.firefox && b.version >= 18) ||
    (b.safari && b.version >= 5) ||
    (b.opera && b.version >= 16) ||
    // If we don't have an iOS version, assume it works
    (b.ios && (b.version === undefined || b.version >= 7)) ||
    (b.android && b.version >= 20)
  ) {
    ok = true;
  }

  var badloc = window.location.href.indexOf('browsercheck.html') > -1;

  if (!ok && !badloc) {
    window.location = 'browsercheck.html';
  } else if (ok && badloc) {
    window.location = '/365FarmNet/';
  }
})();
